import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders the Platform Risk Blotter and Messages widgets through the ADR 0014 owned grid instead
 * of ag-grid. Their complete local row sets come from trading-platform socket/query state rather
 * than table-server TableModels, so they share a dedicated local-row integration and rollout.
 */
export const enableNewPlatformRiskGrid = new FeatureFlag({
    key: 'enable-new-platform-risk-grid',
    createdOn: '2026-08-24',
    defaultValue: false,
});
